import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from '../../service/rest.service';
import { Message } from '../../service/message.service';
import { LoaderService } from '../../service/loader.service';
import { SeoService } from '../../service/seo.service';

@Component({
  selector: 'app-user',
  templateUrl: './home.component.html',
  styles: [],
  standalone: false
})
export class HomeComponent implements OnInit {
  constructor(private router: Router, private rest: RestService, private message: Message, private loader: LoaderService, private seo: SeoService) { }

  hover = -1
  myFormData = new FormData()
  contactForm = {
    name: '',
    email: '',
    subject: '',
    company: '',
    message: ''
  }
  ngOnInit(): void {
    this.seo.updateSeo({
      titleSeo: 'Consulenza e Ricerca Bandi UE | Innovation Plaza',
      metadescription: 'Supportiamo imprese e PA nello sviluppo di progetti innovativi e accesso a bandi europei, nazionali e regionali. Scopri i nostri servizi.',
      url: 'https://innovationplaza.it',
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "@id": "https://innovationplaza.it/#organization",
          "name": "Innovation Plaza S.r.l.",
          "alternateName": ["Innovation Smart Plaza", "InnovationPlaza"],
          "legalName": "Innovation Plaza S.r.l.",
          "url": "https://innovationplaza.it",
          "logo": {
            "@type": "ImageObject",
            "url": "https://innovationplaza.it/assets/logo.svg",
            "width": 300,
            "height": 80
          },
          "image": "https://innovationplaza.it/assets/og-image.jpg",
          "description": "Societa' di consulenza di direzione che supporta imprese, istituzioni e aspiranti imprenditori.",
          "foundingDate": "2022-10-11",
          "taxID": "12590780966",
          "vatID": "IT12590780966",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "email": "info@innovationplaza.it",
            "availableLanguage": [{"@type": "Language", "name": "Italian"}, {"@type": "Language", "name": "English"}]
          }
        },
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "@id": "https://innovationplaza.it/#website",
          "url": "https://innovationplaza.it",
          "name": "Innovation Plaza",
          "publisher": {"@id": "https://innovationplaza.it/#organization"}
        },
        {
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "@id": "https://innovationplaza.it/#localbusiness-milano",
          "name": "Innovation Plaza Sede Nord Italia (Milano)",
          "telephone": "+39-02-49539510",
          "email": "info@innovationplaza.it",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Viale Papiniano, 44",
            "addressLocality": "Milano",
            "addressRegion": "MI",
            "postalCode": "20123",
            "addressCountry": "IT"
          },
          "parentOrganization": {"@id": "https://innovationplaza.it/#organization"}
        },
        {
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "@id": "https://innovationplaza.it/#localbusiness-brindisi",
          "name": "Innovation Plaza Sede Centro-Sud Italia (Brindisi)",
          "email": "info@innovationplaza.it",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Brindisi",
            "addressRegion": "BR",
            "addressCountry": "IT"
          },
          "parentOrganization": {"@id": "https://innovationplaza.it/#organization"}
        }
      ]
    });
  }

  goBandi() {
    this.router.navigate(['cerca-bando'])
  }

  goRegister() {
    this.router.navigate(['registrazione'])
  }

  goTo(route: string) {
    // this.router.navigate(['piani'])
    window.location.replace(route)
  }

  sendEmail() {
    let params = {
      name: this.contactForm.name + ' - ' + this.contactForm.company,
      subject: this.contactForm.subject,
      email: this.contactForm.email,
      message: this.contactForm.message
    }
    this.loader.on()
    this.rest.post('/user/contattaci', params).subscribe({
      next: (value) => {
        this.loader.off(true)
        this.message.showMessage('Email inviata', 'success')
        this.contactForm = {
          name: '',
          email: '',
          subject: '',
          company: '',
          message: ''
        }
      },
      error: (value) => {
        this.loader.off(true)
        this.message.showMessage("Errore nell'invio email", 'error')
        this.contactForm = {
          name: '',
          email: '',
          subject: '',
          company: '',
          message: ''
        }
      },
    })
  }

  openInput() {
    let input = document.getElementById('upload-cv')
    input?.click()
  }

  changeInput(event: any) {
    if (event.target.files[0]) {
      this.loader.on()
      this.myFormData.append('file', event.target.files[0])
      this.rest.post('/user/curriculum', this.myFormData).subscribe({
        next: (value) => {
          this.loader.off(false)
          this.message.showMessage('Curriculum caricato con successo', 'success')
        },
        error: (value) => {
          this.loader.off(false)
          this.message.showMessage('Errore nel caricamento del file', 'error')
        },
      })
    }
  }

  goToContacts() {
    window.location.replace('contatti')
  }
}
